var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 25.4629L24.9961 34.5352V0L9.375 25.4629Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9961 0V34.5352L40.6172 25.4629L24.9961 0Z",
    fill: "#878787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.4902L40.6152 25.4629L25 34.5312V18.4883V18.4902Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9961 18.4883H25V34.5312L24.9961 34.5352L9.375 25.4648L24.9961 18.4902V18.4883Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 28.373L24.9961 49.998V37.4395L9.375 28.373Z",
    fill: "#D7D7D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9961 37.4414V50L40.625 28.375L24.9961 37.4414Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25);
export default __webpack_public_path__ + "static/media/25.16bae5929a383856a1387126e40108cc.svg";
export { ForwardRef as ReactComponent };